var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './index.scss';
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Menu from '~/components/menu';
const DropdownButton = (props) => {
    const { children, className, menuItems, title, onMenuItemClick, onMenuToggle, disabled } = props, rest = __rest(props, ["children", "className", "menuItems", "title", "onMenuItemClick", "onMenuToggle", "disabled"]);
    const [isExpanded, setIsExpanded] = useState(false);
    const buttonRef = useRef(null);
    const buttonClass = classnames(`dropdown-button ${className || ''}`, {
        'btn-focus': isExpanded,
    });
    useEffect(() => {
        function handleClickOutside(event) {
            var _a;
            const target = event.target;
            if (isExpanded && buttonRef && !((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(target)) &&
                !(target === null || target === void 0 ? void 0 : target.classList.contains('menu-item'))) {
                setIsExpanded(!isExpanded);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [buttonRef, isExpanded]);
    useEffect(() => {
        if (onMenuToggle) {
            onMenuToggle(isExpanded);
        }
    }, [isExpanded]);
    return (React.createElement("button", Object.assign({ type: 'button', className: buttonClass, ref: buttonRef, onClick: () => setIsExpanded(!isExpanded), title: title, disabled: disabled }, rest),
        title && React.createElement("span", { className: "title" }, title),
        React.createElement("span", { className: 'expander' },
            React.createElement("span", { key: +isExpanded },
                React.createElement("i", { className: isExpanded ? 'fa-solid  fa-chevron-up' : 'fa-solid fa-chevron-down' }))),
        isExpanded &&
            React.createElement(Menu, { showMenu: isExpanded, setShowMenu: setIsExpanded, onMenuItemClick: onMenuItemClick, menuItems: menuItems, targetRef: buttonRef.current }),
        children));
};
export default DropdownButton;
